export interface PairPosition {
  buyPosition?: Leg;
  sellPosition?: Leg;
  maxProfit: number;
  maxLoss: number;
}

export interface Leg {
  strikePrice: number;
  price: number;
  call: boolean;
  buy: boolean;
  quantity: number;
  maxProfit?: String;
  maxLoss?: String;
}

export interface IStrategy {
  legs: Leg[];
  callBreakEven?: number;
  callBreakEvenPercentage?: number;
  putBreakEven?: number;
  putBreakEvenPercentage?: number;
  maxLoss: number;
  maxProfit: number;
  approxMargin: number;
  title: string;
  expiryDuration: number;
  lotSize: number;
  maxLossROI: number;
  maxProfitROI: number;
  riskRewardRatio: number;
  alert?: string;
  types?: ViewType[];
}

export interface IContractData {
  lastPrice: number;
  strikePrice: number;
  expiryDate: string;
  openInterest: number;
  pchangeinOpenInterest: number;
  changeinOpenInterest: number;
  totalTradedVolume: number;
  pChange: number;
  impliedVolatility?: number;
}

export interface IStrikeData {
  strikePrice: number;
  expiryDates: string;
  CE?: IContractData;
  PE?: IContractData;
}

interface IIndexDataProps {
  index: string;
  last: number;
  low: number;
  open: number;
  percentChange: number;
  previousClose: number;
  variation: number;
  high: number;
}

export interface IRecords {
  expiryDates: string[];
  strikePrices: number[];
  underlyingValue: number;
  timeStamp: string;
  data: IStrikeData[];
  indices: IIndexDataProps[];
}

export enum ViewType {
  "Up",
  "Down",
  "Neutral",
  "Volatile",
  "Moderately Positive",
  "Moderately Negative",
  "Extremely Positive",
  "Extremely Negative",
}

export interface IGenerateStrategyProps {
  viewType: ViewType;
  expiryDate: string;
  data: IRecords;
  lotSize: number;
  shortMargin: number;
  marginBenefit: number;
  maxStrikes: number;
  from: number;
  to: number;
  allowedBreakeven?: number;
}

export interface IStrikeRange {
  startRange: number;
  endRange: number;
}

export interface IOrderData {
  id?: number;
  symbol: string;
  strike: string;
  expiry: string;
  price: number;
  order: "BUY" | "SELL";
  option: "CALL" | "PUT";
  qty: number;
  key: string;
  time: number;
  bookedPNL?: number;
}
